import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import {
    ILegalAcceptanceResponse,
    ILegalRequirementsResponse,
    IRecordLegalAcceptance,
} from '../../entities/Legal/Legal.ts';

export class LegalApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}`;

    public static apiUrls: {
        requirements: string;
        accept: string;
    } = {
        requirements: `${LegalApi.baseApiUrl}/Legal/Requirements`,
        accept: `${LegalApi.baseApiUrl}/Legal/Accept`,
    };

    public static async getRequirements(): Promise<ILegalRequirementsResponse> {
        return this.sendApiRequest<ILegalRequirementsResponse>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.requirements,
        });
    }

    public static async accept(data: IRecordLegalAcceptance): Promise<ILegalAcceptanceResponse> {
        return this.sendApiRequest<ILegalAcceptanceResponse>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.accept,
            data: data,
        });
    }
}
